import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { LogoutComponent } from './features/logout/logout.component';


export const routes: Routes = [
  {
    path: '',
    redirectTo: 'normal-user/ev',  // Redirect to a valid page
    pathMatch: 'full'
  },
  // {
  //   path: 'login',
  //   loadChildren: ()=> import('./login/login.module').then(m=> m.LoginModule)
  // },
  {
    path: 'normal-user',
    loadChildren: () => import('./features/normal-user/normal-user.module').then(m => m.NormalUserModule)
  },
  {
    path: 'power-user',
    loadChildren: () => import('./features/power-user/power-user.module').then(m => m.PowerUserModule)
  },

  {
    path: 'profile',
    loadChildren: () => import('./features/profile/profile.module').then(m => m.ProfileModule)
  },

  {
    path: 'logout-success',
    component: LogoutComponent
  },
  {
    path: '**',
    redirectTo: 'normal-user/ev'
  },

];
@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule]
})
export class AppRoutingModule { }
